import { apiRequest } from "../util/apiUtils";

export const addOneTimePayment = async (payload) => {
  try {
    const res = await apiRequest(
      "post",
      `payment-gateway/create-checkout
`,
      {
        body: payload,
      }
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};
export const addMonthlyPayment = async (payload) => {
  try {
    const res = await apiRequest(
      "post",
      `payment-gateway/create-subscription-checkout
`,
      {
        body: payload,
      }
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const paymentMethodList = async (params) => {
  try {
    const res = await apiRequest("get", `paymentmethod/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const paymentMethodAdminList = async (params) => {
  try {
    const res = await apiRequest("get", `/payment-method/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const paymentMethodAdminAddEdit = async (payload) => {
  try {
    const res = await apiRequest(
      payload?.id ? "put" : "post",
      `paymentmethod/${payload?.id ? "edit" : "add"}`,
      {
        body: payload,
      },
      "multipart/form-data"
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const paymentMethodAdminDelete = async (payload) => {
  try {
    const res = await apiRequest("delete", `paymentmethod/delete-all`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const paymentMethodAdminStatusChange = async (payload) => {
  try {
    const res = await apiRequest("patch", `paymentmethod/status`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
